var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"y-chip",class:[_vm.chipClass, _vm.textSize, _vm.color, _vm.outlinedClass]},[_vm._t("prepend"),_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("default"),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }